<template>
  <PartyDetails kind="vendor" />
</template>

<script>
import PartyDetails from "@/components/party/PartyDetails.vue";

export default {
  name: "supplier-details",
  components: { PartyDetails },
};
</script>
